import type {OrderProduct} from 'modules/Orders/types';

import {cn} from '@ds/helpers';
import {numberFormat} from 'utils/Helper';

import OrderProductBadge from './components/OrderProductBadge/OrderProductBadge';

type OrderProductItemProps = {
  product: OrderProduct;
};

const OrderProductItem: React.FC<OrderProductItemProps> = ({product}) => {
  const hasDiscountedPrice = Boolean(product.discounted_price);

  return (
    <div className={cn('flex flex-1 gap-1.25 p-1.25', product.state === 'deleted' && 'bg-gray-02')}>
      <div className="flex shrink-0 items-center">
        <img
          className="size-15.5 object-contain"
          src={product.imageUrl}
          alt={product.title ?? ''}
        />
      </div>
      <div className="flex min-w-0 flex-1 gap-2.5 border-b border-gray-03 py-1.25 last:border-0">
        <div className="flex min-w-0 flex-1 flex-col gap-2.5">
          <span className="text-body-sm text-gray-09">{product.title}</span>
          <div className="flex flex-wrap items-center gap-1.5 text-body-sm text-gray-09">
            {product.discount !== 0 && (
              <span className="rounded-sm bg-gray-02 px-1.25">{product.discount}%</span>
            )}
            <span className={cn(hasDiscountedPrice && 'text-gray-06 line-through')}>
              {product.price ? numberFormat(product.price) : null}
            </span>
            {hasDiscountedPrice && <span>{numberFormat(product.discounted_price ?? 0)}</span>}
            <span>تومان</span>
          </div>
          <OrderProductBadge state={product.state} />
        </div>
        <span className="shrink-0 px-2 text-body-sm text-gray-09">x{product.quantity}</span>
      </div>
    </div>
  );
};

export default OrderProductItem;
